import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuickFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  compact?: boolean;
}

export const QuickFilter: React.FC<QuickFilterProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className,
  compact = false,
}) => (
  <div className={cn('relative flex items-center', className)}>
    <Search
      className="absolute left-2.5 h-4 w-4 text-nb-text-muted pointer-events-none"
      aria-hidden
    />
    <Input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={cn(
        'pl-8 bg-nb-surface-2 border-nb-border-subtle text-nb-text-primary',
        compact ? 'h-8 text-xs' : 'h-9 text-sm'
      )}
      aria-label="Quick filter"
    />
  </div>
);
